import { render, staticRenderFns } from "./AtualizacaoEscolaridade.vue?vue&type=template&id=603ad9e5&"
import script from "./AtualizacaoEscolaridade.vue?vue&type=script&lang=js&"
export * from "./AtualizacaoEscolaridade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports